import { openBlock, createElementBlock, createStaticVNode } from "vue";
import _export_sfc from "../uikit._virtual/_plugin-vue_export-helper.es.js";
const _sfc_main = {
  name: "uikit-grenier-icon"
};
const _hoisted_1 = {
  width: "21",
  height: "22",
  viewBox: "0 0 21 22",
  fill: "currentColor",
  stroke: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createStaticVNode('<path d="M20.1288 20.3785H14.5043V21.6275H20.1288V20.3785Z" fill="#7442EC"></path><path d="M20.1288 17.8729H14.5043V19.1295H20.1288V17.8729Z" fill="#7442EC"></path><path d="M20.1288 15.3747H14.5043V16.6238H20.1288V15.3747Z" fill="#7442EC"></path><path d="M13.2552 15.3747H0.128784V21.6275H13.2552V15.3747Z" fill="#DDD4FB"></path><path d="M10.1288 0L0.128784 5.88191V14.1257H20.1288V5.88191L10.1288 0ZM13.2552 11.6276C13.254 11.7931 13.1872 11.9515 13.0694 12.0679C12.9516 12.1842 12.7925 12.2491 12.6269 12.2483H7.63069C7.46511 12.2491 7.30595 12.1842 7.18816 12.0679C7.07036 11.9515 7.00354 11.7931 7.00236 11.6276V7.87283C7.00414 7.04481 7.33432 6.25132 7.92044 5.66645C8.50656 5.08159 9.30076 4.75312 10.1288 4.75312C10.9568 4.75312 11.751 5.08159 12.3371 5.66645C12.9232 6.25132 13.2534 7.04481 13.2552 7.87283V11.6276Z" fill="#7442EC"></path><path d="M10.1288 6.00299C9.63206 6.00249 9.1554 6.19908 8.80343 6.54963C8.45147 6.90019 8.25296 7.37605 8.25146 7.87281H12.0062C12.0047 7.37605 11.8062 6.90019 11.4542 6.54963C11.1022 6.19908 10.6256 6.00249 10.1288 6.00299Z" fill="#7442EC"></path><path d="M12.0062 9.12189H8.25146V10.9993H12.0062V9.12189Z" fill="#7442EC"></path>', 7);
const _hoisted_9 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_9);
}
const uikitGrenierIcon = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);
export {
  uikitGrenierIcon as default
};
//# sourceMappingURL=uikit-grenier-icon.vue.es.js.map
